"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.copyText = copyText;
var _vue = _interopRequireDefault(require("vue"));
/**
 * 复制文本到剪贴板并统一结果提示
 * 依赖 main.js 注册的 vue-clipboard2（$copyText）与 element-ui（$notify）
 * @param {string} val 待复制内容
 */
function copyText(val) {
  if (!val) return Promise.resolve();
  return _vue.default.prototype.$copyText(String(val)).then(function () {
    _vue.default.prototype.$notify.success({
      title: '温馨提示',
      message: '拷贝成功'
    });
  }).catch(function () {
    _vue.default.prototype.$notify.error({
      title: '温馨提示',
      message: '拷贝失败，请手动复制'
    });
  });
}